// extracted by mini-css-extract-plugin
export default {"projectLogo":"project-logo_projectLogo__vNowe"};